// We keep the type for the enum in a separate file so that we can import it
// into both client and server code.

export type EnumObjectValues<T> = T[keyof T]
type EnumObjectKeys<T> = Extract<keyof T, string>

export const RoleEnum = {
  USER: 'user',
  ADMIN: 'admin',
  PROVIDER: 'provider',
} as const
export type RoleType = EnumObjectValues<typeof RoleEnum>
export type RoleKeysType = EnumObjectKeys<typeof RoleEnum>

export const StatusEnum = {
  ACTIVE: 'active',
  SUSPENDED: 'suspended',
  PENDING: 'pending',
  ALL: 'all',
} as const
export type StatusType = EnumObjectValues<typeof StatusEnum>
export type StatusKeysType = EnumObjectKeys<typeof StatusEnum>

export const ImageStateEnum = {
  NORMAL: 'normal',
  ZOOM: 'zoom',
  FULLSCREEN: 'fullscreen',
} as const
export type ImageStateType = EnumObjectValues<typeof ImageStateEnum>
export type ImageStateKeysType = EnumObjectKeys<typeof ImageStateEnum>

export const WarrantyTypeEnum = {
  BASIC: 'Basic Retail',
  ADVANCED: 'Advanced Retail',
} as const
export type WarrantyTypes = EnumObjectValues<typeof WarrantyTypeEnum>
export type WarrantyTypesnKeys = EnumObjectKeys<typeof WarrantyTypeEnum>

export const WarrantyTranslationEnum = {
  'Basic Retail': 'Garantía Óptima',
  'Advanced Retail': 'Garantia Premium',
} as const
export type WarrantyTranslationType = EnumObjectValues<
  typeof WarrantyTranslationEnum
>

export const WarrantyDurationEnum = {
  ONE_YEAR: 1,
  TWO_YEARS: 2,
  THREE_YEARS: 3,
} as const
export type WarrantyDurationTypes = EnumObjectValues<
  typeof WarrantyDurationEnum
>
export type WarrantyDurationKeys = EnumObjectKeys<typeof WarrantyDurationEnum>

export const ProductStatusEnums = {
  ACTIVE: 'active',
  DRAFT: 'draft',
  ARCHIVED: 'archived',
} as const

// domingo primero, en js domingo es el dia 0
export const WeekDayEnum = {
  SUNDAY: 'Domingo',
  MONDAY: 'Lunes',
  TUESDAY: 'Martes',
  WEDNESDAY: 'Miércoles',
  THURSDAY: 'Jueves',
  FRIDAY: 'Viernes',
  SATURDAY: 'Sábado',
} as const
export type WeekDayType = EnumObjectValues<typeof WeekDayEnum>
export type WeekDayKeysType = EnumObjectKeys<typeof WeekDayEnum>

export const WeekDayAbrevEnum = {
  MONDAY: 'Lun',
  TUESDAY: 'Mar',
  WEDNESDAY: 'Mie',
  THURSDAY: 'Jue',
  FRIDAY: 'Vie',
  SATURDAY: 'Sab',
  SUNDAY: 'Dom',
  //continuar con todos los dias de la semana sin usar acentos
} as const
export type WeekDayAbrevType = EnumObjectValues<typeof WeekDayAbrevEnum>
export type WeekDayAbrevKeysType = EnumObjectKeys<typeof WeekDayAbrevEnum>

export const LanguageEnum = {
  SPANISH: 'Español',
  ENGLISH: 'Inglés',
  FRENCH: 'Francés',
  CATALAN: 'Catalán',
  BASQUE: 'Euskera',
  ITALIAN: 'Italiano',
} as const
export type LanguageType = EnumObjectValues<typeof LanguageEnum>
export type LanguageKeysType = EnumObjectKeys<typeof LanguageEnum>

export const CouponStatusEnum = {
  ACTIVE: 'active',
  SUSPENDED: 'suspended',
  CLOSED: 'closed',
} as const
export type CouponStatusType = EnumObjectValues<typeof CouponStatusEnum>
export type CouponStatusKeysType = EnumObjectKeys<typeof CouponStatusEnum>

export enum ActionTypeEnum {
  status = 'status',
  create = 'create',
  delete = 'delete',
  disable = 'disable',
  edit = 'edit',
  download = 'download',
  enableDisable = 'enableDisable',
  photo = 'photo',
  addToCart = 'addToCart',
  buy = 'buy',
  get = 'get',
  accept = 'accept',
  reject = 'reject',
  markPurchased = 'markPurchased',
  undoPurchased = 'undoPurchased',
}
export type ActionType = EnumObjectValues<typeof ActionTypeEnum>
export type ActionKeysType = EnumObjectKeys<typeof ActionTypeEnum>

export const PaymentEnum = {
  PAYPAL: 'paypal',
  STRIPE: 'card',
} as const
export type PaymentType = EnumObjectValues<typeof PaymentEnum>
export type PaymentKeysType = EnumObjectKeys<typeof PaymentEnum>

export const ContactTypeEnum = {
  FINANCE: 'finance',
  CERTIFICATION: 'certification',
  BOOKING: 'booking',
  CONTACT: 'contact',
  APPRAISAL: 'appraisal', //appraisal => tasacion
  SEARCH: 'search',
  MORE_INFORMATION: 'moreInformation',
} as const
export type ContactTypeType = EnumObjectValues<typeof ContactTypeEnum>
export type ContactTypeKeysType = EnumObjectKeys<typeof ContactTypeEnum>
export const TypeOfPayment = {
  FINANCIADO: 'Financiado',
  AL_CONTADO: 'Al contado',
} as const
export type TypeOfPaymentType = EnumObjectValues<typeof TypeOfPayment>
export type TypeOfPaymentKeysType = EnumObjectKeys<typeof TypeOfPayment>

export const NotificationEventEnum = {
  AFTER_BUY: 'Después de la compra',
  AFTER_AUTOMATIC_ACCOUNT_CREATION: 'Después creación automática de una cuenta',
} as const
export type NotificationEventType = EnumObjectValues<
  typeof NotificationEventEnum
>
export type NotificationEventeysType = EnumObjectKeys<
  typeof NotificationEventEnum
>

export const IVAEnum = {
  YES: 'Si',
  NO: 'No',
} as const
export type IVAType = EnumObjectValues<typeof IVAEnum>
export type IVAKeysType = EnumObjectKeys<typeof IVAEnum>

export const IrpfEnum = {
  '7%': 7,
  '15%': 15,
} as const
export type IrpfType = EnumObjectValues<typeof IrpfEnum>
export type IrpfKeysType = EnumObjectKeys<typeof IrpfEnum>

export const NotificationStatusEnum = {
  PENDING: 'pending',
  SENDED: 'sended',
  ERROR: 'error',
} as const
export type NotificationStatusType = EnumObjectValues<
  typeof NotificationStatusEnum
>
export type NotificationStatusKeysType = EnumObjectKeys<
  typeof NotificationStatusEnum
>

export const EnvEnum = {
  PRODUCTION: 'production',
  STAGING: 'staging',
  DEV: 'dev',
} as const
export type ModeEnvType = EnumObjectValues<typeof EnvEnum>
export type ModeEnvKeysType = EnumObjectKeys<typeof EnvEnum>

export enum PaymentErrorEnum {
  ALREADY_PAYED = 'alreadyPayed',
  GENERIC = 'true',
  PAYMENT = 'payment', // if payment was made but there was a error creating db data
  NOT_AVAILABLE = 'notAvailable',
  PAID_NOT_AVAILABLE = 'paidNotAvailable',
}
export type PaymentErrorEnumType = EnumObjectValues<typeof PaymentErrorEnum>
export type PaymentErrorEnumKeysType = EnumObjectKeys<typeof PaymentErrorEnum>

export const RegionStockEnum = {
  EUROPE: 'europe',
  AMERICA: 'america',
  CANADA: 'canada',
  AUSTRALIA: 'australia',
  UNITED_KINGDOM: 'united_kingdom',
} as const
export type RegionStockEnumType = EnumObjectValues<typeof RegionStockEnum>

export const OrderEnum = {
  NOT_PAYED: 'noPayed',
  PREPARING: 'preparing',
  SENT: 'sent',
  RECEIVED: 'received',
} as const

export const ProductEnum = {
  SEX_DOLL: 'sexDoll',
  ACCESSORY: 'accessory',
  AR: 'ar',
  AI: 'ai',
} as const

export const HTTPCodeEnum = {
  OK: 200,
  CREATED: 201,
  NO_CONTENT: 204,
  BAD_REQUEST: 400,
  UNAUTHORIZED: 401,
  NOT_FOUND: 404,
  NOT_ALLOWED: 405,
  INTERNAL_ERROR: 500,
} as const

export const MeasureSystemEnum = {
  IMPERIAL: 'imperial',
  METRIC: 'metric',
} as const
export type MeasureSystemEnumType = EnumObjectValues<typeof MeasureSystemEnum>
export type MeasureSystemEnumKeysType = EnumObjectKeys<typeof MeasureSystemEnum>

export const SexDollMaterialsEnum = {
  TPE: 'tpe',
  SILICONE: 'silicone',
  SILICONE_HEAD: 'siliconeHead', //body TPE
} as const
export type SexDollMaterialsEnumType = EnumObjectValues<
  typeof SexDollMaterialsEnum
>

export const CarSortEnum = {
  PRICE_ASC: 'price_asc',
  PRICE_DESC: 'price_desc',
  KM_ASC: 'km_asc',
  MATRICULATION_ASC: 'matriculation_asc',
  MATRICULATION_DESC: 'matriculation_desc',
} as const

export const CarSortLabelEnum = {
  [CarSortEnum.PRICE_ASC]: 'Precio: de menor a mayor',
  [CarSortEnum.PRICE_DESC]: 'Precio: de mayor a menor',
  [CarSortEnum.KM_ASC]: 'Kilómetros: de menor a mayor',
  [CarSortEnum.MATRICULATION_ASC]: 'Año: del más antiguo al más reciente',
  [CarSortEnum.MATRICULATION_DESC]: 'Año: del más reciente al más antiguo',
} as const

export const BreastSizeEnum = {
  // any change here update convertBreastSizeToCupLetters to work in filters
  A: 'A',
  B: 'B',
  C: 'C',
  D: 'D',
  E: 'E',
  F: 'F',
  G: 'G',
  H: 'H',
  I: 'I',
  J: 'J',
  K: 'K',
  L: 'L',
  M: 'M',
  N: 'N',
  O: 'O',
  P: 'P',
  Q: 'Q',
  R: 'R',
  S: 'S',
  HUGE_BREAST: 'Huge Breast',
} as const
export type BreastSizeEnumType = EnumObjectValues<typeof BreastSizeEnum>

export const GenderEnum = {
  MALE: 'male',
  FEMALE: 'female',
  SHEMALE: 'shemale',
}
export type GenderEnumType = EnumObjectValues<typeof GenderEnum>

export const SkinColorEnum = {
  NATURAL: 'natural', //muy blanca
  LIGHT_TAN: 'lightTan', //blanca
  TAN: 'tan', //bronceada
  COLA: 'cola', //muy bronceada
  // fantasy colors
  RED: 'red',
  PURPLE: 'purple',
  LIGHT_BLUE: 'lightBlue',
  BLUE: 'blue',
  YELLOW: 'yellow',
  PINK: 'pink',
  GREEN: 'green',
}
export type SkinColorEnumType = EnumObjectValues<typeof SkinColorEnum>

export const SexDollFiltersEnum = {
  PRICE: 'price',
  STOCK: 'stock',
  CATEGORY: 'category',
  BRAND: 'brand',
  MATERIAL: 'material',
  STYLE: 'style',
  GENDER: 'gender',
  CUP: 'cup',
  HEIGHT: 'height',
  SKIN: 'skin',
  WEIGHT: 'weight',
  TYPE: 'type',
  PAGE: 'page',
  ACCESSORY: 'accessory',
} as const
export type SexDollFiltersEnumType = EnumObjectValues<typeof SexDollFiltersEnum>

export const CategorySexDollFilterEnum = {
  CUSTOMIZABLE: 'customizable',
} as const
export type CategorySexDollFilterEnumType = EnumObjectValues<
  typeof CategorySexDollFilterEnum
>

export const BreastSizeFilterEnum = {
  SMALL: 'small',
  MEDIUM: 'medium',
  LARGE: 'large',
  HUGE: 'huge',
} as const
export type BreastSizeFilterEnumType = EnumObjectValues<
  typeof BreastSizeFilterEnum
>

export const AccessoriesFilterEnum = {
  EXTRA_HEADS: 'Extra Heads',
  CLEANING_KITS: 'Cleaning Kits',
  WIGS: 'Wigs',
  REMOVABLE_VAGINA_INSERT: 'Removable Vagina Insert',
  STORAGE: 'Storage',
  PENIS_ADAPTOR: 'Penis Adaptor',
} as const
export type AccessoriesFilterEnumType = EnumObjectValues<
  typeof AccessoriesFilterEnum
>

export const SexDollTypeEnum = {
  FULL_SEXDOLL: 'fullSexDoll',
  TORSO_WITH_HEAD: 'torsoWithHead',
  TORSO_WITHOUT_HEAD: 'torsoWithoutHead',
  SILICONE_ASS: 'siliconeAss',
} as const
export type SexDollTypeEnumType = EnumObjectValues<typeof SexDollTypeEnum>

export const CurrencyEnum = {
  EUR: 'EUR',
  AED: 'AED',
  AFN: 'AFN',
  ALL: 'ALL',
  AMD: 'AMD',
  ANG: 'ANG',
  AOA: 'AOA',
  ARS: 'ARS',
  AUD: 'AUD',
  AWG: 'AWG',
  AZN: 'AZN',
  BAM: 'BAM',
  BBD: 'BBD',
  BDT: 'BDT',
  BGN: 'BGN',
  BHD: 'BHD',
  BIF: 'BIF',
  BMD: 'BMD',
  BND: 'BND',
  BOB: 'BOB',
  BRL: 'BRL',
  BSD: 'BSD',
  BTN: 'BTN',
  BWP: 'BWP',
  BYN: 'BYN',
  BZD: 'BZD',
  CAD: 'CAD',
  CDF: 'CDF',
  CHF: 'CHF',
  CLP: 'CLP',
  CNY: 'CNY',
  COP: 'COP',
  CRC: 'CRC',
  CUP: 'CUP',
  CVE: 'CVE',
  CZK: 'CZK',
  DJF: 'DJF',
  DKK: 'DKK',
  DOP: 'DOP',
  DZD: 'DZD',
  EGP: 'EGP',
  ERN: 'ERN',
  ETB: 'ETB',
  FJD: 'FJD',
  FKP: 'FKP',
  FOK: 'FOK',
  GBP: 'GBP',
  GEL: 'GEL',
  GGP: 'GGP',
  GHS: 'GHS',
  GIP: 'GIP',
  GMD: 'GMD',
  GNF: 'GNF',
  GTQ: 'GTQ',
  GYD: 'GYD',
  HKD: 'HKD',
  HNL: 'HNL',
  HRK: 'HRK',
  HTG: 'HTG',
  HUF: 'HUF',
  IDR: 'IDR',
  ILS: 'ILS',
  IMP: 'IMP',
  INR: 'INR',
  IQD: 'IQD',
  IRR: 'IRR',
  ISK: 'ISK',
  JEP: 'JEP',
  JMD: 'JMD',
  JOD: 'JOD',
  JPY: 'JPY',
  KES: 'KES',
  KGS: 'KGS',
  KHR: 'KHR',
  KID: 'KID',
  KMF: 'KMF',
  KRW: 'KRW',
  KWD: 'KWD',
  KYD: 'KYD',
  KZT: 'KZT',
  LAK: 'LAK',
  LBP: 'LBP',
  LKR: 'LKR',
  LRD: 'LRD',
  LSL: 'LSL',
  LYD: 'LYD',
  MAD: 'MAD',
  MDL: 'MDL',
  MGA: 'MGA',
  MKD: 'MKD',
  MMK: 'MMK',
  MNT: 'MNT',
  MOP: 'MOP',
  MRU: 'MRU',
  MUR: 'MUR',
  MVR: 'MVR',
  MWK: 'MWK',
  MXN: 'MXN',
  MYR: 'MYR',
  MZN: 'MZN',
  NAD: 'NAD',
  NGN: 'NGN',
  NIO: 'NIO',
  NOK: 'NOK',
  NPR: 'NPR',
  NZD: 'NZD',
  OMR: 'OMR',
  PAB: 'PAB',
  PEN: 'PEN',
  PGK: 'PGK',
  PHP: 'PHP',
  PKR: 'PKR',
  PLN: 'PLN',
  PYG: 'PYG',
  QAR: 'QAR',
  RON: 'RON',
  RSD: 'RSD',
  RUB: 'RUB',
  RWF: 'RWF',
  SAR: 'SAR',
  SBD: 'SBD',
  SCR: 'SCR',
  SDG: 'SDG',
  SEK: 'SEK',
  SGD: 'SGD',
  SHP: 'SHP',
  SLE: 'SLE',
  SLL: 'SLL',
  SOS: 'SOS',
  SRD: 'SRD',
  SSP: 'SSP',
  STN: 'STN',
  SYP: 'SYP',
  SZL: 'SZL',
  THB: 'THB',
  TJS: 'TJS',
  TMT: 'TMT',
  TND: 'TND',
  TOP: 'TOP',
  TRY: 'TRY',
  TTD: 'TTD',
  TVD: 'TVD',
  TWD: 'TWD',
  TZS: 'TZS',
  UAH: 'UAH',
  UGX: 'UGX',
  USD: 'USD',
  UYU: 'UYU',
  UZS: 'UZS',
  VES: 'VES',
  VND: 'VND',
  VUV: 'VUV',
  WST: 'WST',
  XAF: 'XAF',
  XCD: 'XCD',
  XDR: 'XDR',
  XOF: 'XOF',
  XPF: 'XPF',
  YER: 'YER',
  ZAR: 'ZAR',
  ZMW: 'ZMW',
  ZWL: 'ZWL',
} as const
export type CurrencyEnumType = EnumObjectValues<typeof CurrencyEnum>

export enum CouponTypeEnum {
  USELIMIT = 'useLimit',
  DATAPERIOD = 'datePeriod',
}

export const enum ToastTitleEnum {
  ERROR = 'Error',
  CREATED = 'Creado',
}

export const FeatureCategoryEnum = {
  SAFETY: 'Seguridad',
  COMFORT: 'Comfort',
  OUTDOOR: 'Exterior',
  INDOOR: 'Interior',
  MULTIMEDIA: 'Multimedia y audio',
  OTHER_ACCESSORIES: 'Otros accesorios',
} as const
export type FeatureCategoryType = EnumObjectValues<typeof FeatureCategoryEnum>

export const CarBrandEnum = {
  ABARTH: 'Abarth',
  ALFA_ROMEO: 'Alfa Romeo',
  ALPINE: 'Alpine',
  AUDI: 'Audi',
  BMW: 'BMW',
  CHEVROLET: 'Chevrolet',
  CITROEN: 'Citroen',
  CUPRA: 'CUPRA',
  DACIA: 'Dacia',
  DFSK: 'DFSK',
  DS: 'DS',
  FIAT: 'Fiat',
  FORD: 'Ford',
  HONDA: 'Honda',
  HYUNDAI: 'Hyundai',
  INFINITI: 'Infiniti',
  JAGUAR: 'Jaguar',
  JEEP: 'Jeep',
  KGM_SSANGYONG: 'Kgm/Ssangyong',
  KIA: 'Kia',
  LAND_ROVER: 'Land Rover',
  LEXUS: 'Lexus',
  LYNK_AND_CO: 'Lynk & Co',
  MAZDA: 'Mazda',
  MERCEDES_BENZ: 'Mercedes Benz',
  MG: 'MG',
  MINI: 'Mini',
  MITSUBISHI: 'Mitsubishi',
  NISSAN: 'Nissan',
  OPEL: 'Opel',
  PEUGEOT: 'Peugeot',
  PORSCHE: 'Porsche',
  RENAULT: 'Renault',
  SAAB: 'Saab',
  SEAT: 'SEAT',
  SKODA: 'Skoda',
  SMART: 'Smart',
  SUBARU: 'Subaru',
  SUZUKI: 'Suzuki',
  TESLA: 'Tesla',
  TOYOTA: 'Toyota',
  VOLKSWAGEN: 'Volkswagen',
  VOLVO: 'Volvo',
} as const

export type CarBrandType = EnumObjectValues<typeof CarBrandEnum>
export type CarBrandKeysType = EnumObjectKeys<typeof CarBrandEnum>

export const CategoryEnum = {
  SUV_4X4: 'SUV / 4x4',
  COMPACTO: 'Compacto',
  DEPORTIVO: 'Deportivo',
  BERLINA: 'Berlina',
  COUPE: 'Coupé',
  HATCHBACK: 'Hatchback',
  CABRIO: 'Cabrio',
} as const

export type CategoryType = EnumObjectValues<typeof CategoryEnum>
export type CategoryKeysType = EnumObjectKeys<typeof CategoryEnum>

export const TractionEnum = {
  DELANTERA: 'Delantera',
  TRASERA: 'Trasera',
  INTEGRAL: 'Integral',
} as const
export type TractionType = EnumObjectValues<typeof TractionEnum>
export type TractionKeysType = EnumObjectKeys<typeof TractionEnum>

export const TransmissionEnum = {
  MANUAL: 'Manual',
  AUTOMATICO: 'Automático',
} as const
export type TransmissionType = EnumObjectValues<typeof TransmissionEnum>
export type TransmissionKeysType = EnumObjectKeys<typeof TransmissionEnum>

export const EcoLabelEnum = {
  ECO: 'Etiqueta ECO',
  C: 'Etiqueta C',
  CERO: 'Etiqueta 0',
  B: 'Etiqueta B',
} as const
export type EcoLabelType = EnumObjectValues<typeof EcoLabelEnum>
export type EcoLabelKeysType = EnumObjectKeys<typeof EcoLabelEnum>

export const FuelTypeEnum = {
  DIESEL: 'Diésel',
  GASOLINA: 'Gasolina',
  HIBRIDO: 'Híbrido',
  HIBRIDO_ENCHUFABLE: 'Híbrido enchufable',
  MILD_HYBRID: 'Mild Hybrid',
  ELECTRICO: 'Eléctrico',
  GAS: 'Gas',
  BIODIESEL: 'Biodiésel',
  HIDROGENO: 'Hidrógeno',
} as const
export type FuelTypeType = EnumObjectValues<typeof FuelTypeEnum>
export type FuelTypeKeysType = EnumObjectKeys<typeof FuelTypeEnum>

export const CarColorEnum = {
  AMARILLO: 'Amarillo',
  AZUL: 'Azul',
  BEIGE: 'Beige',
  BLANCO: 'Blanco',
  GRIS: 'Gris',
  MARRON: 'Marrón',
  NEGRO: 'Negro',
  NARANJA: 'Naranja',
  PLATEADO: 'Plateado',
  ROJO: 'Rojo',
  VERDE: 'Verde',
  VERDE_CLARO: 'Verde claro',
} as const
export type CarColorType = EnumObjectValues<typeof CarColorEnum>
export type CarColorKeysType = EnumObjectKeys<typeof CarColorEnum>

export const ConditionEnum = {
  EXCELENTE: 'Excelente',
  NUEVO: 'Como Nuevo',
  SEMINUEVO: 'Seminuevo',
  BUEN_ESTADO: 'Buen estado',
} as const
export type ConditionType = EnumObjectValues<typeof ConditionEnum>
export type ConditionKeysType = EnumObjectKeys<typeof ConditionEnum>
